import type { MenuCheckbox } from 'root/clientTypes';
import { isSectionChecked, isPriceShowed } from 'root/utils/display';
import { useItemsContext } from 'root/contexts/ItemsContext';
import { useItemsDisplayValues } from 'root/hooks/useItemsDisplayValues';
import type { ItemVariant } from 'root/apiTypes';

export const useVariantLogic = ({ variant }: { variant: ItemVariant }) => {
  const { sectionId } = useItemsContext();

  const {
    showItemVariantsCurrency,
    showZeroPrice,
    checkPricingMenus,
    showZeroPriceToAll,
    variantTitleHtmlTag,
    variantPriceHtmlTag,
  } = useItemsDisplayValues();

  const formattedPrice = showItemVariantsCurrency
    ? variant.priceInfo.formattedPrice
    : variant.priceInfo.formattedPriceNoCurrency ?? '';

  const priceOptionSectionChecked =
    showZeroPriceToAll || isSectionChecked(checkPricingMenus as MenuCheckbox[], sectionId ?? '');

  const shouldShowVariantsPrice = isPriceShowed({
    price: variant.priceInfo.price ?? '',
    showZeroPrice: showZeroPrice as boolean,
    sectionChecked: priceOptionSectionChecked as boolean,
  });

  return {
    formattedPrice,
    shouldShowVariantsPrice,
    variantTitleHtmlTag,
    variantPriceHtmlTag,
  };
};
